import useGridAccessApproval from '~/store-v2/registration/useGridAccessApproval'
import {
  normalizeInstallationLocation,
  resolveAccessOpinionMode,
} from '~/ui-blocks/Formalization/blocks/electricityBill/electricityBill.utils'

/**
 * Grid access approval (parecer de acesso) requirement for the installation site of the project.
 * The rule lives in the customer-register; the front only reads the display mode.
 */
export function useAccessOpinionRequirement(
  projectId: Ref<string>,
  city: Ref<string | null | undefined>,
  state: Ref<string | null | undefined>,
) {
  const location = computed(() => normalizeInstallationLocation(city.value, state.value))

  const { data, isError, isLoading } = useGridAccessApproval(projectId, location)

  const hasLocation = computed(() => Boolean(location.value))

  const mode = computed(() => resolveAccessOpinionMode({
    hasLocation: hasLocation.value,
    isError: isError.value,
    displayMode: data.value?.display_mode,
  }))

  const isEvaluating = computed(() => hasLocation.value && isLoading.value)

  const isFallback = computed(() => hasLocation.value && isError.value)

  return {
    mode,
    isEvaluating,
    isFallback,
  }
}
